export function asteriskTextFormatting(input) {
  const elements = []

  // tilføj \*\*\*(.+?)\*\*\*| til starten af regexen og
  // inkluder nedenstående hvis CPH vil have fed skråtekst.
  const regex = /(\*\*(.+?)\*\*|\*(.+?)\*)/g

  let lastIndex = 0
  let match
  let key = 0

  while ((match = regex.exec(input)) !== null) {
    const [fullMatch] = match
    const matchIndex = match.index

    if (lastIndex < matchIndex) {
      elements.push(input.slice(lastIndex, matchIndex))
    }

    // inkommentér hvis og inkrementer de andre array accessors, hvis fed skråtekst ønskes.
    // if (match[2] !== undefined) {
    //   elements.push(
    //     <strong key={key++}>
    //       <em>{match[2]}</em>
    //     </strong>,
    //   )
    if (match[2] !== undefined) {
      elements.push(<strong key={key++}>{match[2]}</strong>)
    } else if (match[3] !== undefined) {
      elements.push(<em key={key++}>{match[3]}</em>)
    }

    lastIndex = matchIndex + fullMatch.length
  }

  // Add remaining plain text
  if (lastIndex < input.length) {
    elements.push(input.slice(lastIndex))
  }

  return elements.length === 0 ? input : <>{elements}</>
}
